export const TEMPLATE_FORMS = {
  MAU_PHIEU_DON_THUOC: 1,
  MAU_PHIEU_TU_VAN: 2,
  MAU_PHIEU_KHAM_BENH_NOI_KHOA: 3,
  MAU_PHIEU_CHI_DINH_CLS: 4,
  MAU_PHIEU_KET_QUA_XN: 5
}
